import styled from 'styled-components'

export const MobileSearchPopupWrapper = styled.div`
  width: 100%;
  min-height: 290px;
  background: white;
  padding: 20px 18px;
  box-sizing: border-box;
`
